const allIcons = {
  burger: require("./iconsFolder/iconBurger.png"),
  "burger@2x": require("./iconsFolder/iconBurger@2x.png"),
  calendar: require("./iconsFolder/iconCalendar.png"),
  "calendar@2x": require("./iconsFolder/iconCalendar@2x.png"),
  calendar_no_date: require("./iconsFolder/iconCalendarNoDate.png"),
  "calendar_no_date@2x": require("./iconsFolder/iconCalendarNoDate@2x.png"),
  ceo_change: require("./iconsFolder/iconCeoChange.png"),
  "ceo_change@2x": require("./iconsFolder/iconCeoChange@2x.png"),
  ceo_change_filled: require("./iconsFolder/iconCeoChangeFilled.png"),
  "ceo_change_filled@2x": require("./iconsFolder/iconCeoChangeFilled@2x.png"),
  checkmark: require("./iconsFolder/iconCheckmark.png"),
  "checkmark@2x": require("./iconsFolder/iconCheckmark@2x.png"),
  company_anniversary: require("./iconsFolder/iconCompanyAnniversary.png"),
  "company_anniversary@2x": require("./iconsFolder/iconCompanyAnniversary@2x.png"),
  company_anniversary_filled: require("./iconsFolder/iconCompanyAnniversaryFilled.png"),
  "company_anniversary_filled@2x": require("./iconsFolder/iconCompanyAnniversaryFilled@2x.png"),
  company_change: require("./iconsFolder/iconCompanyChange.png"),
  "company_change@2x": require("./iconsFolder/iconCompanyChange@2x.png"),
  company_change_filled: require("./iconsFolder/iconCompanyChangeFilled.png"),
  "company_change_filled@2x": require("./iconsFolder/iconCompanyChangeFilled@2x.png"),
  company_move: require("./iconsFolder/iconCompanyMove.png"),
  "company_move@2x": require("./iconsFolder/iconCompanyMove@2x.png"),
  company_move_filled: require("./iconsFolder/iconCompanyMoveFilled.png"),
  "company_move_filled@2x": require("./iconsFolder/iconCompanyMoveFilled@2x.png"),
  insolvency: require("./iconsFolder/iconInsolvency.png"),
  "insolvency@2x": require("./iconsFolder/iconInsolvency@2x.png"),
  insolvency_filled: require("./iconsFolder/iconInsolvencyFilled.png"),
  "insolvency_filled@2x": require("./iconsFolder/iconInsolvencyFilled@2x.png"),
  job_offer: require("./iconsFolder/iconJobOffer.png"),
  "job_offer@2x": require("./iconsFolder/iconJobOffer@2x.png"),
  job_offer_filled: require("./iconsFolder/iconJobOfferFilled.png"),
  "job_offer_filled@2x": require("./iconsFolder/iconJobOfferFilled@2x.png"),
  lock_filled: require("./iconsFolder/iconLockFilled.png"),
  "lock_filled@2x": require("./iconsFolder/iconLockFilled@2x.png"),
  logout: require("./iconsFolder/iconLogout.png"),
  "logout@2x": require("./iconsFolder/iconLogout@2x.png"),
  new_company: require("./iconsFolder/iconNewCompany.png"),
  "new_company@2x": require("./iconsFolder/iconNewCompany@2x.png"),
  new_company_filled: require("./iconsFolder/iconNewCompanyFilled.png"),
  "new_company_filled@2x": require("./iconsFolder/iconNewCompanyFilled@2x.png"),
  reset: require("./iconsFolder/iconReset.png"),
  "reset@2x": require("./iconsFolder/iconReset@2x.png"),
  shareholder_change: require("./iconsFolder/iconShareholderChange.png"),
  "shareholder_change@2x": require("./iconsFolder/iconShareholderChange@2x.png"),
  share_holder_change_filled: require("./iconsFolder/iconShareHolderChangeFilled.png"),
  "share_holder_change_filled@2x": require("./iconsFolder/iconShareHolderChangeFilled@2x.png"),
  swipe_left: require("./iconsFolder/iconSwipeLeft.png"),
  "swipe_left@2x": require("./iconsFolder/iconSwipeLeft@2x.png"),
  user_filled: require("./iconsFolder/iconUserFilled.png"),
  "user_filled@2x": require("./iconsFolder/iconUserFilled@2x.png")
};

export default function getIcons(id) {
  return allIcons[id];
}
